export default {"src":"/_next/static/media/CMG.5c6a9b2a.svg","height":18,"width":18};